import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-holiday';

export default function Example() {
  return (
    <>
      <Head>
        <title>The Poshmark Holiday Guide: What Items to Sell and How To Boost Your Sales</title>
        <meta
          name='description'
          content='Be in the know of the holiday items and selling strategies to help you make the most out of this festive – and generous – time of the year!'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-holiday' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-holiday' />
        <meta
          property='og:title'
          content='The Poshmark Holiday Guide: What Items to Sell and How To Boost Your Sales'
        />
        <meta
          property='og:description'
          content='Be in the know of the holiday items and selling strategies to help you make the most out of this festive – and generous – time of the year!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-12-19T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-12-19T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
